import { useState } from "react";
import { useDebounce } from "src/hooks/useDebounce";

interface UseServerSearchOptions {
	debounceMs?: number;
	initialValue?: string;
	onChange?: (value: string) => void;
}

export function useServerSearch({
	debounceMs = 500,
	initialValue = "",
	onChange,
}: UseServerSearchOptions = {}) {
	const [searchValue, setSearchValueState] = useState(initialValue);
	const debouncedSearch = useDebounce(searchValue, debounceMs);

	const setSearchValue = (value: string) => {
		setSearchValueState(value);
		onChange?.(value);
	};

	return {
		searchValue,
		setSearchValue,
		debouncedSearch,
		trimmedSearch: debouncedSearch.trim(),
		clearSearch: () => setSearchValue(""),
	};
}
